import React from 'react';

export function SkeletonRow({ className = '' }) {
  return <div className={`animate-pulse bg-white/5 rounded h-4 ${className}`} />;
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`animate-pulse bg-white/[0.03] border border-white/10 rounded-xl p-5 ${className}`}>
      <div className="h-4 bg-white/10 rounded w-3/4 mb-3" />
      <div className="h-3 bg-white/10 rounded w-1/2 mb-2" />
      <div className="h-3 bg-white/10 rounded w-2/3" />
    </div>
  );
}

export function SkeletonGrid({ count = 6, className = 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' }) {
  return (
    <div className={`grid gap-4 ${className}`}>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, cta }) {
  return (
    <div className="text-center py-16 px-4">
      {Icon && <Icon className="w-16 h-16 text-text-muted/40 mx-auto mb-4" />}
      <h3 className="font-serif text-xl text-text-light mb-2">{title}</h3>
      {description && <p className="text-text-muted text-sm max-w-md mx-auto mb-6">{description}</p>}
      {cta}
    </div>
  );
}
